import { Unstable_Grid2 as Grid } from '@mui/material';

import { TextField, Select } from '@occc-app/design-system';
import { parseNumber } from '@occc-app/lib/finalFormUtils';

import { pointBalanceOperatorOptions, pointTargetingPeriodOptions } from './constants';
import { PointBalanceOperatorValues } from '../types';

export type PointBalanceTargetingAttributeProps = {
  pointBalanceFieldName: string;
  operator: PointBalanceOperatorValues;
};

export const PointBalanceTargetingAttribute = ({
  pointBalanceFieldName,
  operator,
}: PointBalanceTargetingAttributeProps) => {
  const isBetweenOperator = operator === 'BETWEEN';

  return (
    <Grid container spacing={3} mb={2}>
      <Grid xs={12} sm={6} md={3}>
        <Select
          name={`${pointBalanceFieldName}.operator`}
          label='Member has'
          data={pointBalanceOperatorOptions}
          formControlProps={{ size: 'medium', margin: 'none' }}
        />
      </Grid>

      <Grid xs={12} sm={6} md={3}>
        <TextField
          name={`${pointBalanceFieldName}.points`}
          label={isBetweenOperator ? 'Lower Points Limit' : 'Number of Points'}
          fieldProps={{
            parse: parseNumber,
          }}
        />
      </Grid>

      {isBetweenOperator && (
        <Grid xs={12} sm={6} md={3}>
          <TextField
            name={`${pointBalanceFieldName}.toPoints`}
            label='Upper Points Limit'
            fieldProps={{
              parse: parseNumber,
            }}
          />
        </Grid>
      )}

      <Grid xs={12} sm={6} md={3}>
        <Select
          name={`${pointBalanceFieldName}.period`}
          label='Period'
          data={pointTargetingPeriodOptions}
          formControlProps={{ size: 'medium', margin: 'none' }}
        />
      </Grid>
    </Grid>
  );
};
